import { Button, ButtonProps } from "@mui/material";

export type AppButtonVariant = "action" | "cancel";

export interface AppButtonProps extends Omit<ButtonProps, "variant" | "color"> {
  /** action: Save/OK/Submit...; cancel: Cancel/Huỷ/Close... */
  appVariant?: AppButtonVariant;
  /** default: 32px; large: 40px, aligned with form fields (search/dropdown) */
  appSize?: "default" | "large";
}

// Single source of truth for button styling. See "Button style" in CLAUDE.md.
export const BUTTON_ACTION_COLOR = "#a11f4c";
const BUTTON_ACTION_HOVER_COLOR = "#8a1a41";
const BUTTON_DEFAULT_WIDTH = 120;
const BUTTON_HEIGHT = 32;
const BUTTON_HEIGHT_LARGE = 40;

const actionSx = {
  backgroundColor: BUTTON_ACTION_COLOR,
  color: "#fff",
  boxShadow: "none",
  "&:hover": { backgroundColor: BUTTON_ACTION_HOVER_COLOR, boxShadow: "none" },
  "&.Mui-disabled": {
    backgroundColor: BUTTON_ACTION_COLOR,
    color: "#fff",
    opacity: 0.5,
  },
};

const cancelSx = {
  backgroundColor: "background.paper",
  color: "text.primary",
  borderColor: "var(--app-border)",
  "&:hover": { borderColor: BUTTON_ACTION_COLOR, color: BUTTON_ACTION_COLOR, backgroundColor: "background.paper" },
};

const AppButton = ({ appVariant = "action", appSize = "default", sx, ...rest }: AppButtonProps) => {
  const isAction = appVariant === "action";
  return (
    <Button
      variant={isAction ? "contained" : "outlined"}
      disableElevation
      sx={[
        {
          minWidth: BUTTON_DEFAULT_WIDTH,
          height: appSize === "large" ? BUTTON_HEIGHT_LARGE : BUTTON_HEIGHT,
          borderRadius: "6px",
          textTransform: "none",
          fontWeight: 400,
        },
        isAction ? actionSx : cancelSx,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    />
  );
};

export default AppButton;
